export const responsive = {
    largeDesktop: {
      breakpoint: { max: 1920, min: 1441 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 1440, min: 1280 }, 
      items: 4,
    },
    smallDesktop: {
      breakpoint: { max: 1279, min: 1025 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 767, min: 0 },
      items: 2,
    },
    smallMobile: {
      breakpoint: { max: 380, min: 0 },
      items: 1,
    },
  };
  